import {
  MonacoFileEditor,
  type MonacoFileEditorProps
} from '../monacoFileEditor/MonacoFileEditor';

export type TextEditorPageProps = Omit<MonacoFileEditorProps, 'mode'>;

/** Plain-text Text Editor shell (txt/log/env/jenc). */
export function TextEditorPage(props: TextEditorPageProps) {
  return <MonacoFileEditor {...props} mode="text" />;
}
